export function filenameParts(filename: string) {
    const lastDot = filename.lastIndexOf('.');
    if (lastDot !== -1) {
        const name = filename.substring(0, lastDot);
        const extension = filename.substring(lastDot);
        return [name, extension];
    }
    return [filename, null];
}
